import React from "react";

function PhysicalExamDisplay({ data, showFooter }) {
  return (
    <div className="physical-exam-display">
      <h3>Physical Exam Preview</h3>
      <pre>{JSON.stringify(data, null, 2)}</pre>
      {showFooter && <div className="physical-exam-preview-footer">Generated by PhysicalExamDisplay</div>}
    </div>
  );
}

export default PhysicalExamDisplay;
